import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { CustomField } from '@classes/bizzmine/custom-field';
import { environment } from '@environments/environment';
import { ProjectInfo } from '@classes/bizzmine/project-info';
import { AuthService } from '@services/auth.service';
import { LicenceRoleType } from '@enums/licence-role-type.enum';

@Component({
  selector: 'app-bizzmine',
  templateUrl: './bizzmine.component.html',
  styleUrls: ['./bizzmine.component.scss']
})
export class BizzmineComponent implements OnInit {

  cryptedUrl: SafeResourceUrl;
  isLoading = true;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.initBizzmine();
  }

  private initBizzmine(): void {
    const token = this.authService.getDecodedToken();
    const customFields: CustomField[] = [
        {​ value: token.email, id: environment.customFieldEmail }​,
        {​ value: token.language, id: environment.customFieldLanguage }​,
        {​ value: token.licence, id: environment.customFieldCommune ​},
        {​ value: 'Mail', id: environment.customFieldContact ​},
    ];
    const projectInfo = new ProjectInfo (
      environment.bizzmineApiKey,
      token.name,
      environment.bizzmineProjectName,
      token.language,
      customFields,
      !(token.role === LicenceRoleType.bko || token.role === LicenceRoleType.bzd) // isFiltered
    );
    this.cryptedUrl = `${environment.bizzmineUrl}${btoa(unescape(encodeURIComponent(JSON.stringify(projectInfo))))}`;
  }
}
